<div class="search-overlay" [class.search-overlay--open]="isOpen">
  <div class="search-overlay__background" (click)="close()"></div>

  <div class="search-overlay__header">
    <div class="search-overlay-header">
      <h2 class="search-overlay-header__title">
        {{ 'filters.common.filter' | i18n }}
      </h2>

      <button class="search-overlay-header__close" (click)="close()">
        <i
          class="search-overlay-header__close-icon material-icon material-icon--outlined"
        >
          close
        </i>
      </button>
    </div>
  </div>

  <div class="search-overlay__main">
    <lib-search-box #searchBox (selectRegion)="openMobileFilters()">
    </lib-search-box>
  </div>
</div>
